import type * as React from "react";

import { cn } from "@/lib/utils";

/**
 * The only place in this console that takes prose: the typed reason every
 * destructive action demands before it will write to the audit log. Set in
 * sans, not mono — it is a sentence a human will read back in six months, not
 * a code.
 */
function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      data-slot="textarea"
      className={cn(
        "field-sizing-content block min-h-16 w-full rounded-[2px] border border-rule-strong bg-sunk px-2.5 py-2",
        "font-sans text-[0.9375rem] leading-relaxed text-ink transition-colors",
        "placeholder:text-ink-3",
        "hover:border-ink-3 focus-visible:border-ink focus-visible:-outline-offset-2",
        "aria-invalid:border-hold",
        "disabled:cursor-not-allowed disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
}

export { Textarea };
